import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { globalThemeMode } from "stores/reducers/global/selectors";
import { themes } from "styles/themeConstant";

const Hamburger: React.FC<React.HTMLProps<HTMLSpanElement>> = ({
  ...props
}) => {
  const isDarkMode = useSelector(globalThemeMode);

  const theme = useMemo(() => {
    return isDarkMode ? themes.dark : themes.light;
  }, [isDarkMode]);

  const color = useMemo(() => {
    return theme.textSecondary;
  }, [theme]);

  return (
    <span style={{ cursor: "pointer" }} {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 18H21"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 12H21"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 6H21"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default Hamburger;
